export default __webpack_public_path__ + "static/media/fv_icon.7c944ef9.svg";